import { AccountService } from '@/user/apis/account/account.api'
import { AppliedInfo } from '@/user/models/applied-info'
import { CompletedInfo } from '@/user/models/completed-info'
import { UserCertificationsInfo } from '@/user/models/certification/user-certification'

export default {
  namespaced: true,
  state: () => ({
    appliedLectures: null,
    completedLectures: null,
    certifications: null,
  }),
  mutations: {
    appliedLectures(state, value) {
      state.appliedLectures = value
    },
    completedLectures(state, value) {
      state.completedLectures = value
    },
    certifications(state, value) {
      state.certifications = value
    },
  },
  actions: {
    async getAppliedLectures({ commit }, params) {
      try {
        const data = await AccountService.getAppliedLectures(params)
        commit('appliedLectures', new AppliedInfo(data))
        return data
      } catch ({ response: { status } }) {
        return status
      }
    },
    async getCompletedLectures({ commit }, params) {
      try {
        const data = await AccountService.getCompletedLectures(params)
        commit('completedLectures', new CompletedInfo(data))
        return data
      } catch ({ response: { status } }) {
        return status
      }
    },
    async getCertifications({ commit }, { page, size } = {}) {
      try {
        const data = await AccountService.getCertifications({ page, size })
        commit('certifications', new UserCertificationsInfo(data))
        return data
      } catch (error) {
        return error?.response?.status || 500
      }
    },
  },
  getters: {
    appliedLectures(state) {
      return state.appliedLectures
    },
    completedLectures(state) {
      return state.completedLectures
    },
    certifications(state) {
      return state.certifications
    },
  },
}
